import { render, staticRenderFns } from "./UserDashboardPage.vue?vue&type=template&id=4b008060&scoped=true&"
import script from "./UserDashboardPage.vue?vue&type=script&lang=js&"
export * from "./UserDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardPage.vue?vue&type=style&index=0&id=4b008060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b008060",
  null
  
)

export default component.exports